import type { Auth0Client } from "./types/auth0Client";
import type { LoginAppState } from "./types";
import { isLoginReason } from "./utils";

export const handleAuthCallback = (auth0Client: Auth0Client): Promise<Auth0Client> => {
    const url = new URL(location.href);
    const searchParams = url.searchParams;
    const isRedirectCallback = searchParams.has('code') && searchParams.has('state');

    return isRedirectCallback
        ? auth0Client.handleRedirectCallback()
            .then((result) => {
                const appState = result?.appState as LoginAppState | undefined;

                if (appState && isLoginReason(appState)) {
                    if (window.snowplowTracker?.coreTracker && typeof window.snowplowTracker.coreTracker.trackLoginSuccess === 'function') {
                        window.snowplowTracker.coreTracker.trackLoginSuccess(appState);
                    } else {
                        console.warn("Login tracking: trackLoginSuccess is not available.");
                    }
                }

                url.searchParams.delete('code');
                url.searchParams.delete('state');
                history.replaceState({}, document.title, url.toString());

                return auth0Client;
            })
        : Promise.resolve(auth0Client);
}
